import { useHostedAddProjectStore } from "../../hosted/hostedAddProjectStore";
import { useHostedModeState } from "../../hosted/useHostedMode";
import { useHostedProjects } from "../../hosted/useHostedProjects";
import { HostedAddProjectDialog } from "./HostedAddProjectDialog";

/**
 * Mounts the hosted Add Project dialog next to the app's other global dialogs.
 * Every Add Project entry point routes through the command palette, which opens
 * this via the hosted store, so there is one dialog instance for the whole app.
 */
export function HostedAddProjectDialogHost() {
  const { hostedSurfacesEnabled } = useHostedModeState();
  const open = useHostedAddProjectStore((state) => state.open);
  const setOpen = useHostedAddProjectStore((state) => state.setOpen);

  if (!hostedSurfacesEnabled) {
    return null;
  }

  return <MountedHostedAddProjectDialog open={open} setOpen={setOpen} />;
}

function MountedHostedAddProjectDialog({
  open,
  setOpen,
}: {
  readonly open: boolean;
  readonly setOpen: (open: boolean) => void;
}) {
  // The hook also drives the initial project list, which is what makes a newly
  // created project appear in the sidebar and workspace immediately.
  const { createProject, selectProject } = useHostedProjects();

  return (
    <HostedAddProjectDialog
      open={open}
      onOpenChange={setOpen}
      onCreate={createProject}
      onCreated={(project) => selectProject(project.id)}
    />
  );
}
